import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { FaBars, FaTimes, FaLeaf, FaInfo, FaImages, FaHome, FaShoppingCart, FaUtensils } from 'react-icons/fa';
import headerStyles from './Header.module.css';

const Header = ({ cartItemsCount = 0 }) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      toggleMenu();
    }
  };

  return (
    <header className={headerStyles.header} role="banner">
      <div className={headerStyles.container}>
        <Link to="/" className={headerStyles.logo} aria-label="Folsom Microgreens Home">
          <img
            src={`${process.env.PUBLIC_URL}/images/logo.png`}
            alt="Folsom Microgreens"
            className={headerStyles.logoImage}
          />
          <h1 className={headerStyles.visuallyHidden}>Folsom Microgreens</h1>
        </Link>

        <button
          className={headerStyles.menuButton}
          onClick={toggleMenu}
          onKeyPress={handleKeyPress}
          aria-expanded={isMenuOpen}
          aria-controls="main-navigation"
          aria-label={isMenuOpen ? "Close menu" : "Open menu"}
        >
          {isMenuOpen ? <FaTimes /> : <FaBars />}
        </button>

        <nav 
          id="main-navigation"
          className={`${headerStyles.nav} ${isMenuOpen ? headerStyles.active : ''}`}
          role="navigation"
          aria-label="Main navigation"
        >
          <ul className={headerStyles.navList}>
            <li>
              <Link 
                to="/" 
                className={headerStyles.navLink}
                aria-current={window.location.pathname === '/' ? 'page' : undefined}
              >
                <FaHome /> Home
              </Link>
            </li>
            <li>
              <Link
                to="/chefs"
                className={headerStyles.navLink}
                aria-current={window.location.pathname === '/chefs' ? 'page' : undefined}
              >
                <FaUtensils /> For Chefs
              </Link>
            </li>
            <li>
              <Link
                to="/microgreens"
                className={headerStyles.navLink}
                aria-current={window.location.pathname === '/microgreens' ? 'page' : undefined}
              >
                <FaLeaf /> Microgreens
              </Link>
            </li>
            <li>
              <Link 
                to="/about" 
                className={headerStyles.navLink}
                aria-current={window.location.pathname === '/about' ? 'page' : undefined}
              >
                <FaInfo /> About
              </Link>
            </li>
            <li>
              <Link 
                to="/photogallery" 
                className={headerStyles.navLink}
                aria-current={window.location.pathname === '/photogallery' ? 'page' : undefined}
              >
                <FaImages /> Gallery
              </Link>
            </li>
            <li>
              <Link 
                to="/cart" 
                className={headerStyles.navLink}
                aria-current={window.location.pathname === '/cart' ? 'page' : undefined}
              >
                <FaShoppingCart /> Cart
                {cartItemsCount > 0 && (
                  <span className={headerStyles.cartCount}>{cartItemsCount}</span>
                )}
              </Link>
            </li>
          </ul>
        </nav>
      </div>
    </header>
  );
};

export default Header;